import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { Fab } from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import request from '@/utils/request';
import { Controller } from 'react-hook-form';
import XLSX from 'xlsx';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useSelector } from 'dva';
import LabelRulesStyled from './LabelRulesStyled';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { getToken } from '@/utils/token';
import { RadioFieldCom } from '../../../../label_manage/components/FormType';

export default ({
  queryType, //编辑 详情
  control,
  errors,
  setValue,
  getValues,
  setFileList,
  fileList,
}) => {
  const [disabled, setDisabled] = useState(false);
  const { typeList } = useSelector((state) => state.crowdImport);

  //删除文件
  const handleFileListDelete = ({ selfId }) => {
    const list = fileList.filter((item) => item.id !== selfId);
    setFileList([...list]);
    setValue('url', list.length > 0 ? JSON.stringify(list) : '');
  };

  //下载文件
  const handleDownloadUrl = ({ selfId }) => {
    if (queryType === 'detail') {
      return;
    }
    fileList.forEach((item) => {
      if (item.id === selfId) {
        const apiToken = `${getToken()}`;
        const a = document.createElement('a');
        a.download = item.fileName;
        a.href = `${
          window.location.origin
        }/bizgrowth/web/v1/common/download?uri=${encodeURIComponent(
          item.url,
        )}&access_token=${apiToken}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    });
  };

  console.log('fileList', fileList);
  //关于编辑状态
  useEffect(() => {
    if (queryType === 'detail') {
      setDisabled(true);
    }
  }, [queryType]);
  // 下载模版
  const handleClickDownload = () => {
    if (queryType === 'detail') {
      return;
    }
    const importId = getValues('importId');
    const url = typeList.find(
      (item) => item.value === importId,
    )?.fileTemplateUrl;
    let aLink = document.createElement('a');
    aLink.download = 'ExternalTagBlankTamplate.xlsx'; //文件名随意
    aLink.href = `${process.env.FILE_URL}/${url}`;
    aLink.click();
    aLink.remove();

    // getValues('importId') === '1'
    //     ? `${process.env.CDN_URL}/DEV/PROFILE_CROWD_PACK_IMPORT/外部导入人群模版 - 会员号_202304231131401081.xlsx`
    //     : `${process.env.CDN_URL}/DEV/PROFILE_CROWD_PACK_IMPORT/外部导入人群模版 - 手机号_202304231430122707.xlsx`; //后台给的静态地址
  };

  //生成唯一id
  function guid() {
    return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
      36,
    );
  }

  // 上传文件
  const uploadFile = (formData, fileName) => {
    if (queryType !== 'detail') {
      request('/common/upload', {
        method: 'POST',
        data: formData,
      })
        .then((res) => {
          if (res.code === 0) {
            const fileObj = { id: guid(), ...res.data, fileName };
            setFileList([fileObj]);
            document.getElementById('inputFile').value = null;
            setValue('url', JSON.stringify(fileList));
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: '失败',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // 外部导入标签
  const importLabel = () => {
    return (
      <Box className="external_import">
        <Box mt={3}>
          <RadioFieldCom
            initLabel={true} //自定义的label是否显示
            label="ID类型" //label
            queryType={queryType} //detail不可编辑用于详情
            fontSize="16px"
            control={control}
            lWidth="auto"
            name="importId"
            typeList={typeList}
          />
        </Box>
        <Box sx={{ fontSize: 16, mt: 3 }} style={{ color: '#212100' }}>
          <span style={{ color: 'red' }}>*</span>文件路径{' '}
          <span style={{ color: '#ccc', marginLeft: '12px', fontSize: '12px' }}>
            文件小于10M
          </span>
          {errors && errors.url && (
            <span
              style={{ color: 'red', fontSize: '12px', marginLeft: '10px' }}
            >
              上传文件是必选项
            </span>
          )}
        </Box>
        <div className="export-wrapper" style={{ marginTop: 12 }}>
          <Fab
            variant="extended"
            size="small"
            color={queryType === 'detail' ? '#fff' : 'primary'}
            aria-label="add"
            className="download"
            sx={{ mr: 1.6 }}
            onClick={handleClickDownload}
            disabled={queryType === 'detail' ? 'disabled' : null}
          >
            <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
            下载模版
          </Fab>
          <Fab
            variant="extended"
            size="small"
            color={queryType === 'detail' ? '#fff' : 'primary'}
            aria-label="add"
            className="uploadFile"
            sx={{ position: 'relative' }}
            disabled={queryType === 'detail' ? 'disabled' : null}
          >
            <Controller
              render={(rp) => {
                return (
                  <input
                    className="fileInput"
                    name="url"
                    style={{
                      position: 'absolute',
                      left: '0px',
                      top: '0px',
                      opacity: 0,
                    }}
                    disabled={disabled}
                    type="file"
                    id="inputFile"
                    accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    label="上传文件"
                    rules={{ required: true }}
                    onChange={(e) => {
                      // setFileName(e.target.value); //"C:\fakepath\MemberBlackTemplate.csv"
                      let file = e.target.files;
                      if (file?.[0].size > 1024 * 1024 * 10) {
                        window.message.toast({
                          type: 'error',
                          message: '文件不能超过10M',
                          title: '失败',
                        });
                        document.getElementById('inputFile').value = null;
                        return;
                      }
                      let formData = new FormData(); //{}
                      const fileName = file[0].name; //文件名
                      if (file) {
                        console.log('file', file);
                        const reader = new FileReader();
                        reader.readAsBinaryString(file[0]);
                        reader.onload = function (ed) {
                          try {
                            const data = ed.target.result;
                            const workbook = XLSX.read(data, {
                              type: 'binary',
                            });
                            const sheetName = workbook.SheetNames[0];
                            const worksheet = workbook.Sheets[sheetName];
                            const range = XLSX.utils.decode_range(
                              worksheet['!ref'],
                            );
                            const rowCount = range.e.r + 1;
                            if (!rowCount || rowCount < 2) {
                              window.message.toast({
                                type: 'error',
                                message: '上传的文件中没有数据',
                                title: '',
                              });
                              document.getElementById('inputFile').value = null;
                              return;
                            }
                            formData.append('file', file[0]);
                            formData.append('isFixedName', true);
                            formData.append('isPublic', false);
                            formData.append(
                              'bucket',
                              'PROFILE_CROWD_PACK_IMPORT',
                            );
                            uploadFile(formData, fileName);
                          } catch (error) {
                            formData.append('file', file[0]);
                            formData.append('isFixedName', true);
                            formData.append('isPublic', false);
                            formData.append(
                              'bucket',
                              'PROFILE_CROWD_PACK_IMPORT',
                            );
                            uploadFile(formData, fileName);
                          }
                        };
                      }
                      return rp.onChange(e);
                    }}
                  />
                );
              }}
              name="url"
              type="file"
              label="上传文件"
              control={control}
              rules={{ required: true }}
            />
            <FormHelperText error={Boolean(errors.file)}>
              {Boolean(errors?.file?.type === 'required') && '请上传文件'}
            </FormHelperText>
            <UnarchiveIcon sx={{ width: '24px', height: '24px' }} />
            上传文件
          </Fab>
        </div>
        {fileList &&
          fileList.length > 0 &&
          fileList.map((item) => {
            return (
              <Box
                className="file_name"
                mt={2.6}
                style={{
                  color: queryType === 'detail' ? '#ccc' : '##1565c0',
                }}
                key={item.id}
              >
                <span
                  style={{
                    cursor: queryType === 'detail' ? 'default' : 'pointer',
                  }}
                  onClick={() => {
                    handleDownloadUrl({ selfId: item.id });
                  }}
                >
                  {item.fileName}
                </span>
                {queryType === 'detail' ? (
                  ''
                ) : (
                  <HighlightOffIcon
                    sx={{
                      width: '24px',
                      height: '24px',
                      color: 'rgba(0, 0, 0, 0.26)',
                      marginLeft: '9px',
                      cursor: 'pointer',
                      verticalAlign: 'middle',
                    }}
                    key={item.id}
                    onClick={() => {
                      handleFileListDelete({ selfId: item.id });
                    }}
                  />
                )}
              </Box>
            );
          })}
      </Box>
    );
  };

  return (
    <LabelRulesStyled
      queryType={queryType}
      color={queryType === 'detail' ? 'rgba(0, 0, 0, 0.38)' : '##1565c0'}
    >
      <Box>{importLabel()}</Box>
    </LabelRulesStyled>
  );
};
